import { useEffect, useState, useRef } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import {
  Footer,
  TryEdworking,
  Header,
  EdworkingPromotion,
  SimilarArticles,
  asPathMap,
  Offer,
  TopBanner,
} from '../../js/components'
import {
  OrganizationSchema,
  WebPageSchema,
  BreadcrumbListSchema,
  FAQSchema,
} from '../../js/schemas'
import Image from 'next/image'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks

export async function getStaticPaths() {
  return {
    paths: [
      { locale: 'en', params: { tool: 'paragraph-typing-test' } },
      { locale: 'it', params: { tool: 'test-di-battitura' } },
      { locale: 'es', params: { tool: 'prueba-de-escritura' } },
      { locale: 'fr', params: { tool: 'test-de-dactylographie' } },
      { locale: 'de', params: { tool: 'tipp-test' } },
      { locale: 'pt', params: { tool: 'teste-de-digitação' } },
    ],
    fallback: false,
  }
}

export async function getStaticProps({ locale, locales, params }) {
  const { tool } = params
  const res1 = await fetch(process.env.NEXT_PUBLIC_VENUSAUR, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      operationName: 'GetBlogsApproved4',
      query:
        'query GetBlogsApproved4($language: String){getBlogsApproved4(language: $language){id rawTitle color title article category cover resume author { firstname lastname } createdAt}}',
      variables: { language: locale },
    }),
  })
  const data = await res1.json()
  const blogs = data.data.getBlogsApproved4

  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'tools.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  if (!content || !content.tools || !content.tools[tool] || !content.tools[tool].faqs)
    return { notFound: true }
  return {
    props: {
      content,
      blogs,
      locale,
      locales,
      tool,
      paragraph: content.tools[tool].paragraphs[Math.floor(Math.random() * 10)],
    },
  }
}

export default function Tools({ blogs, content, locale, locales, paragraph, tool }) {
  const [promotion, setPromotion] = useState(false)

  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }

  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])

  const listfaqs = content?.tools[tool]?.faqs?.content?.map((f, i) => {
    return { question: f.question, answer: f.answer }
  })

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema
        name={`${content.head.title}`}
        description={`${content.head.description}`}
      />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Tools',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}tools`,
          },
          {
            name: `Paragraph Typing Test - Edworking Tools`,
            url: `https://edworking.com${locale !== 'en' ? `/${locale}` : ''}${asPathMap(
              '/tools/paragraph-typing-test'
            )}`,
          },
        ]}
      />
      <FAQSchema faqs={listfaqs} />
      <Head>
        <title>{content.head.title}</title>
        <meta itemProp="name" content={content.head.title} />
        <meta itemProp="description" content={content.head.description} />
        <meta name="description" content={content.head.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}${asPathMap(
              '/tools/paragraph-typing-test',
              locale1
            )}`}
          />
        ))}
        <link
          rel="alternate"
          href={`https://edworking.com/tools/paragraph-typing-test`}
          hrefLang="x-default"
        />
        <link
          rel="canonical"
          href={`https://edworking.com${locale !== 'en' ? `/${locale}` : ''}${asPathMap(
            '/tools/paragraph-typing-test',
            locale
          )}`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      <Offer content={content.lifetime} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header content={content.header} topbanner={true} />
      <ParagraphTest
        content={content.tools[tool]}
        paragraph={paragraph}
        explore={content.explore}
      />
      <FaqsGeneral
        content={content.tools[tool].faqs.content}
        head={content.tools[tool].faqs.head}
      />
      <SimilarArticles similar={blogs} title={'Popular Articles'} />
      <TryEdworking content={content.endbanner} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}

const ParagraphTest = ({ content, paragraph: initialParagraph, explore }) => {
  const [paragraph, setParagraph] = useState(initialParagraph)
  const [text, setText] = useState('')
  const [matched, setMatched] = useState('')
  const [time, setTime] = useState(0)
  const [isActive, setIsActive] = useState(false)
  const [finished, setFinished] = useState(false)
  const { rates } = content

  const handleText = (e) => {
    const value = e.target.value
    if (value === '') resetTimer()
    if (text === '') setIsActive(true)
    setText(value)
    let tempMatch = ''
    for (let i = 0; i < value.length; i++) {
      if (value[i] === paragraph[i]) {
        tempMatch += value[i]
      } else {
        break
      }
    }
    setMatched(tempMatch)
  }
  useEffect(() => {
    if (matched === paragraph) {
      handleFinish()
    }
  }, [matched])

  useEffect(() => {
    if (initialParagraph) setParagraph(initialParagraph)
  }, [initialParagraph])

  useEffect(() => {
    let interval
    if (isActive) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1)
      }, 1000)
    } else if (!isActive && time !== 0) {
      clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [isActive, time])

  const resetTimer = () => {
    setTime(0)
    setFinished(false)
    setIsActive(false)
    setText('')
    setMatched('')
  }

  const getMinutes = () => {
    return String(Math.floor(time / 60)).padStart(2, '0')
  }

  const getSeconds = () => {
    return String(time % 60).padStart(2, '0')
  }
  const handleFinish = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const wpm = Math.ceil(matched.split(' ').length / (time / 60))
      let typeScores = JSON.parse(localStorage.getItem('typeScores'))
      if (typeScores == null) typeScores = []
      if (typeScores.length > 9) typeScores = typeScores.slice(1)
      typeScores.push(wpm)
      localStorage.setItem('typeScores', JSON.stringify(typeScores))
      setIsActive(false)
      setFinished(true)
    }
  }
  const wpm =
    Math.ceil(matched.split(' ').length / (time / 60)) === Infinity
      ? 0
      : Math.ceil(matched.split(' ').length / (time / 60))
  if (!explore) return null
  return (
    <section className="paragraph-tool" id="features">
      <h1>{content.h1title}</h1>
      <div className="description">{content.description}</div>

      <div className="paragraph">
        <span className="matched-chars">{matched}</span>
        <span className="next-char">
          {paragraph.substring(matched.length, matched.length + 1)}
        </span>
        <span className="unmatched-chars">{paragraph.substring(matched.length + 1)}</span>
      </div>
      <textarea
        placeholder={content.placeholder}
        className="inputParagraph"
        type="text"
        value={text}
        onChange={handleText}
      />
      <div className="timer">
        {getMinutes()}:{getSeconds()}
      </div>

      <div className="banner offer test type">
        <div className="text">
          <div className="headline">{explore.title}</div>
          <div className="subheadline">{explore.description1}</div>
          <div className="bottom" style={{ marginTop: -20, marginBottom: -20 }}>
            <a className="blueButton" href="https://app.edworking.com/signup/user/">
              {explore.cta1}
            </a>
          </div>
          <div className="subheadline2">{explore.description2}</div>
          <div className="strengths">
            {explore.features.map((f, i) => (
              <div key={i} className="strength">
                <Image width={24} height={24} src={f.image} alt="" />
                <span>{f.feature}</span>
                <p>{f.description}</p>
              </div>
            ))}
          </div>
          <div className="bottom" style={{ marginBottom: -10 }}>
            <a className="whiteButton" href="https://edworking.com/features">
              {explore.cta2}
            </a>
          </div>
        </div>
      </div>

      {isActive && (
        <div className="blueButton" onClick={() => resetTimer()}>
          {content.button}
        </div>
      )}
      {finished && (
        <section className="edpromotion typetest">
          <div className="newsletter container">
            <div className="image">
              <ProgressRing value={wpm} />
            </div>
            <div className="text">
              <div className="newsTitle">{rates[getRate(wpm)].title}</div>
              <div className="description">{rates[getRate(wpm)].description}</div>
              <div className="blueButton" onClick={() => resetTimer()}>
                {content.button}
              </div>
            </div>
            <div className="footer">
              <h5>{content.scores}</h5>
              <table className="scores">
                <thead>
                  <tr>
                    {Array.from({ length: 10 }).map((_, number) => (
                      <th key={number}>{number + 1}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {JSON.parse(localStorage.getItem('typeScores'))
                      .reverse()
                      .map((score, index) => (
                        <td key={index}>
                          {score}
                          <span>WPM</span>
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      )}
      <h2>{content.typist.title}</h2>
      <div className="description">{content.typist.description}</div>

      <div className="strengths">
        <div className="strength">
          <Image width={50} height={50} src={'/images/type/turtle.png'} alt="" />
          <span>{rates.veryslow.title}</span>
          <p>0-20wpm</p>
        </div>
        <div className="strength">
          <Image width={50} height={50} src={'/images/type/walk.png'} alt="" />
          <span>{rates.slow.title}</span>
          <p>20-40wpm</p>
        </div>
        <div className="strength">
          <Image width={50} height={50} src={'/images/type/clock.png'} alt="" />
          <span>{rates.average.title}</span>
          <p>40-60wpm</p>
        </div>
        <div className="strength">
          <Image width={50} height={50} src={'/images/type/running.png'} alt="" />
          <span>{rates.fast.title}</span>
          <p>60-80wpm</p>
        </div>
        <div className="strength">
          <Image width={50} height={50} src={'/images/type/rocket.png'} alt="" />
          <span>{rates.veryfast.title}</span>
          <p>80-100wpm</p>
        </div>
        <div className="strength">
          <Image width={50} height={50} src={'/images/type/medal.png'} alt="" />
          <span>{rates.professional.title}</span>
          <p>100wpm</p>
        </div>
      </div>

      {content.questions.map((c, i) => (
        <div className={`plane-wrapper`} key={i}>
          <div className="plane-title">
            <p className="title">{c.question}</p>
            <p className="description">{c.answer}</p>
          </div>
          <div className="plane-inner">
            <div className={`plane`}>
              <Image
                width={460}
                height={490}
                className="img"
                style={{ borderRadius: 15, height: 'auto' }}
                src={c.image}
                alt="Tasks"
              />
            </div>
          </div>
        </div>
      ))}
    </section>
  )
}

export const FaqsGeneral = ({ content, head }) => {
  return (
    <section className="freques">
      <h2 className="title">{head.title}</h2>
      {content?.map((c, i) => (
        <div className="faq" key={i}>
          <input id={`faq-${i}`} type="checkbox" />
          <label htmlFor={`faq-${i}`}>
            <p className="faq-heading">{c.question}</p>
            <div className="faq-arrow"></div>
            <p className="faq-text">{c.answer}</p>
          </label>
        </div>
      ))}
    </section>
  )
}

const getRate = (wpm) => {
  if (wpm < 20) {
    return 'veryslow'
  } else if (wpm < 40) {
    return 'slow'
  } else if (wpm < 60) {
    return 'average'
  } else if (wpm < 80) {
    return 'fast'
  } else if (wpm < 100) {
    return 'veryfast'
  } else {
    return 'professional'
  }
}

const ProgressRing = ({ value }) => {
  const ringRef = useRef(null)
  useEffect(() => {
    if (ringRef.current) {
      let length = ringRef.current.getTotalLength()
      let to = length * ((100 - value) / 100)
      ringRef.current.getBoundingClientRect()
      ringRef.current.style.strokeDashoffset = Math.max(0, to)
      ringRef.current.nextElementSibling.textContent = `${value}`
    }
  }, [])

  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      data-value="50"
    >
      <circle r="45" cx="50" cy="50" />
      <path
        ref={ringRef}
        className="meter"
        d="M5,50a45,45 0 1,0 90,0a45,45 0 1,0 -90,0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="282.78302001953125"
        strokeDasharray="282.78302001953125"
      />
      <text x="50" y="42" textAnchor="middle" dominantBaseline="central" fontSize="40"></text>
      <text x="50" y="70" textAnchor="middle" dominantBaseline="central" fontSize="12">
        WPM
      </text>
    </svg>
  )
}
